import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";


const TermsOfService= lazy(()=>import("src/pages/termsOfService"));

export const termsOfService = [
  {
    path: "",
    element: (  
        <Suspense>    
          <Outlet />
        </Suspense>
    ),
    children: [
      {
        path: "termsOfService",
        index: true,
        element: <TermsOfService />,
      }
    ],
  },
];
